<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listItem"
        title-table="Item"
        module="itemSettingsModule"
        sort-name="descricao"
        add-permission="ROLE_ITEM_PROTOCOLO_INSERIR"
        delete-permission="ROLE_ITEM_PROTOCOLO_DELETAR"
        view-permission="ROLE_ITEM_PROTOCOLO_CONSULTAR"
        edit-permission="ROLE_ITEM_PROTOCOLO_ATUALIZAR"
        @add="addNew"
        @edit="edit"
      />
      <FormItem v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "vuex";
import TableComponents from "@/layouts/components/TableComponents.vue";
import { BRow, BCol } from "bootstrap-vue";

import FormItem from "./forms/FormItem.vue";

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormItem,
  },
  computed: {
    ...mapState("itemSettingsModule", {
      listItem: (state) => state.listItem,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: "Id",
          field: "id",
        },
        {
          label: "Descrição",
          field: "descricao",
        },
        {
          label: "Ativo",
          field: "ativo",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
    };
  },
  methods: {
    addNew() {
      this.showForm = true;
    },
    edit(data) {
      this.$store.dispatch("itemSettingsModule/prepareToEdit", data);
      this.showForm = true;
    },
    cancelar() {
      this.showForm = false;
    },
  },
};
</script>
